import clsx from 'clsx';

interface IconProps {
  icon: React.ReactNode;
  className?: string;
  color?: 'inherit' | 'primary' | 'secondary' | 'secondary-inverse' | 'white' | 'light' | 'black' | 'red';
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export const Icon = (props: IconProps) => {
  return (
    <div
      className={clsx(
        !props.color && 'text-slate dark:text-white',
        props.color === 'inherit' && 'text-inherit',
        props.color === 'primary' && 'text-primary',
        props.color === 'secondary' && 'text-primary dark:text-soft-black',
        props.color === 'secondary-inverse' && 'text-soft-black dark:text-primary',
        props.color === 'white' && 'text-white',
        props.color === 'light' && 'text-light',
        props.color === 'black' && 'text-soft-black',
        props.color === 'red' && 'text-red',
        props.className,
      )}
      onClick={props.onClick}
    >
      {props.icon}
    </div>
  );
};
